// extracted by mini-css-extract-plugin
export default {"ExampleTypeScript":"ExampleTypeScript-module__ExampleTypeScript--hHax","title":"ExampleTypeScript-module__title--KeDK","text":"ExampleTypeScript-module__text--Keqc"};